import { render, staticRenderFns } from "./TopFlash.vue?vue&type=template&id=606df02a&"
import script from "./TopFlash.vue?vue&type=script&lang=js&"
export * from "./TopFlash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports